import React, { useState, useEffect } from "react";
import "./SelectChannel.css";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SelectChannel({ activeIndex }) {

  const isUSDT = activeIndex === 4;

  const [selectedChannel, setSelectedChannel] = useState(0);

  // Reset channel when tab changes
  useEffect(() => {
    setSelectedChannel(0);
  }, [activeIndex]);

  const normalChannels = [
    { name: "Phonepe_QR", balance: "100-50K" },
    { name: "GooglePay_QR", balance: "100-50K" },
    { name: "Paytm_QR", balance: "100-50K" },
  ];

  const usdtChannels = [
    { name: "USDT - TRC20 (Tronpay)", balance: "100-50K" },
    { name: "USDT - TRC20 (Upay)", balance: "100-50K" },
    { name: "USDT - TRC20 (Upay)", balance: "100-50K" },
    { name: "USDT - TRC20 (Upay)", balance: "100-50K" },
  ];

  return (
    <div className="select_channel deposit_card_box">
      <div className="card_box">

        <div className="section_header">
          <span className="icon_box">
            <FontAwesomeIcon icon={faBook} />
          </span>
          <h4>Select Channel</h4>
        </div>

        {/* NORMAL CHANNELS */}
        {!isUSDT && (
          <div className="row">
            {normalChannels.map((item, index) => (
              <div className="col-6 px-1" key={index}>
                <div
                  className={`channel_box ${
                    selectedChannel === index ? "active" : ""
                  }`}
                  onClick={() => setSelectedChannel(index)}
                >
                  <p>{item.name}</p>
                  <span>Balance: {item.balance}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* USDT CHANNELS */}
        {isUSDT &&
          usdtChannels.map((item, index) => (
            <div
              key={index}
              className={`channel_box usdt_channel ${
                selectedChannel === index ? "active" : ""
              }`}
              onClick={() => setSelectedChannel(index)}
            >
              <div className="channel_left">
                <img
                  src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                  alt="usdt"
                  className="usdt_img"
                />
              </div>

              <div className="channel_text">
                <p>{item.name}</p>
                <span>Balance: {item.balance}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default SelectChannel;